import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" style={{ textAlign: 'center' }}>
      <div className="footer-top">
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
          <div className="footer-grid">
            <div className="footer-about">
              <h3 className="footer-title">KWCD</h3>
              <p>
                Empowering women and children in Kayamandi through education, support, and community development programs.
              </p>
            </div>

            <div className="footer-links">
              <h4 className="footer-heading" style={{ color: '#ffffff', fontSize: '1.5rem', fontWeight: 700, margin: '0 auto 1.5rem', textTransform: 'uppercase', letterSpacing: '1px', position: 'relative', paddingBottom: '0.75rem' }}>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/vision">Our Vision</Link></li>
                <li><Link to="/programs">Programs</Link></li>
                <li><Link to="/team">Our Team</Link></li>
                <li><Link to="/gallery">Gallery</Link></li>
              </ul>
            </div>

            <div className="footer-contact">
              <h4 className="footer-heading" style={{ color: '#ffffff', fontSize: '1.5rem', fontWeight: 700, margin: '0 auto 1.5rem', textTransform: 'uppercase', letterSpacing: '1px', position: 'relative', paddingBottom: '0.75rem' }}>Contact Us</h4>
              <ul className="contact-info">
                <li>
                  <i className="fas fa-map-marker-alt"></i>
                  <span>16 Sokuqala Street, Kayamandi, 7600</span>
                </li>
                <li>
                  <i className="fas fa-phone"></i>
                  <a href="tel:+27718416784">+27 71 841 6784</a>
                </li>
                <li>
                  <i className="fas fa-envelope"></i>
                  <a href="mailto:info@kwcdp.co.za">info@kwcdp.co.za</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-social" style={{
        backgroundColor: '#000000',
        padding: '2rem 0',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        borderBottom: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div className="container" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(45px, max-content))',
          justifyContent: 'center',
          gap: '1.5rem',
          maxWidth: '300px',
          margin: '0 auto',
          padding: '0 1rem'
        }}>
          {[
            { icon: 'facebook-f', url: 'https://facebook.com' },
            { icon: 'twitter', url: 'https://twitter.com' },
            { icon: 'instagram', url: 'https://instagram.com' }
          ].map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.icon}
              style={{
                color: '#ffffff',
                fontSize: '1.25rem',
                transition: 'all 0.3s ease',
                backgroundColor: 'rgba(255,255,255,0.1)',
                width: '45px',
                height: '45px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none'
              }}
            >
              <i className={`fab fa-${social.icon}`}></i>
            </a>
          ))}
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Kayamandi Women & Children's Development. All Rights Reserved.</p>
            <div className="footer-legal">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span>|</span>
              <Link to="/terms">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
